import React from 'react';
import { CgCreditCard , CgUserlane, CgBriefcase, CgStack, CgPhone, CgBulb, CgDatabase, CgFileDocument, CgChevronDoubleUpR } from "react-icons/cg";
import { Link } from 'react-router-dom';
import { BiSolidArrowToTop, BiArrowBack } from "react-icons/bi";
import { useLocation } from 'react-router-dom';

const Navigation = (props) => {
    
    const [isLanding, setIsLanding] = React.useState(true);
    let location = useLocation();
    
    React.useEffect( ()=> {
        if (location.pathname !== "/") {
            setIsLanding(false);
        }
        else {
            setIsLanding(true);
        }
        } , [location]
    );

    const hadleScrollToTop = () => {
        window.scrollTo(0, 0);
    }
      

    const links = [
        <Link onClick={()=> document.getElementById('me')?.scrollIntoView()} className='nav_button current  me'>
            <CgUserlane size={25}/>
            <p>Me</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_exp')?.scrollIntoView()} className='nav_button current '>
            <CgBriefcase size={25}/>
            <p>Exp</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_projects')?.scrollIntoView()} className='nav_button current '>
            <CgDatabase size={25}/>
            <p>Projects</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_skills')?.scrollIntoView()} className='nav_button current '>
            <CgStack size={25}/>
            <p>Skills</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_creds')?.scrollIntoView()} className='nav_button current '>
            <CgCreditCard size={25}/>
            <p>Creds</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_contact')?.scrollIntoView()} className='nav_button current '>
            <CgPhone size={25}/>
            <p>Contact</p>
        </ Link>,
        <Link  onClick={()=> document.getElementById('me_resume')?.scrollIntoView()} className='nav_button current '>
            <CgFileDocument size={25}/>
            <p>Resume</p>
        </ Link>,
        <Link onClick={()=> document.getElementById('me_ideas')?.scrollIntoView()} className='nav_button current '>
            <CgBulb size={25}/>
            <p>Ideals</p>
        </ Link>,
    ]

    return(
        <div className='navigation' style={{justifyContent: isLanding? "center": "flex-start"}}>
            <span style={{marginTop: "5vh"}} />
            {!isLanding && <Link to="/">
                <BiArrowBack  size={25}/>
                <p style={{fontSize: 10}}>Exlpore</p>
            </Link>}
            {isLanding && links}
            <span style={{marginTop: "5vh"}} />
            <BiSolidArrowToTop onClick={hadleScrollToTop} size={30} color='grey'/>
            <span style={{fontSize: 10, color: "grey"}}>Back to Top</span>
        </div>
    )
}

export default Navigation;